import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, SectionHeader } from "./Reveal";
import { PROCESS } from "../data/site";

const HowWeWork = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.7", "end 0.6"] });
  const lineScale = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section id="process" data-testid="process-section" className="relative py-28 md:py-40">
      <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-2 gap-16">
        <div className="lg:sticky lg:top-32 self-start">
          <SectionHeader
            index={3}
            overline="How We Work"
            title={<>From Requirement<br />to <span className="text-smipl-orange">Reality.</span></>}
            sub="A disciplined five-phase delivery model. No surprises, no orphaned systems, no disappearing vendors."
          />
        </div>
        <div ref={ref} className="relative pl-10">
          <div className="absolute left-[7px] top-2 bottom-2 w-px bg-white/10" />
          <motion.div style={{ scaleY: lineScale }} className="absolute left-[7px] top-2 bottom-2 w-px bg-smipl-orange origin-top" />
          {PROCESS.map((p, i) => (
            <Reveal key={p.step} delay={i * 0.05} className="relative mb-12 last:mb-0">
              <span className="absolute -left-10 top-1 flex h-4 w-4 items-center justify-center">
                <span className="absolute h-4 w-4 rounded-full border border-smipl-orange/50" />
                <span className="h-1.5 w-1.5 rounded-full bg-smipl-orange" />
              </span>
              <div data-testid={`process-step-${i + 1}`} className="tracing-border rounded-2xl border border-white/8 bg-white/[0.03] p-7 transition-all duration-300 hover:-translate-y-1 hover:bg-white/[0.05]">
                <p className="font-mono text-[11px] tracking-[0.3em] text-smipl-orange">PHASE {String(i + 1).padStart(2, "0")}</p>
                <h3 className="mt-2 font-display text-xl md:text-2xl font-bold">{p.step}</h3>
                <p className="mt-3 text-sm md:text-base text-slate-400 leading-relaxed">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;
